import u from "./index879.js";
var o = Math.max;
function d(i, e, g) {
  return e = o(e === void 0 ? i.length - 1 : e, 0), function() {
    for (var n = arguments, r = -1, h = o(n.length - e, 0), l = Array(h); ++r < h; )
      l[r] = n[e + r];
    r = -1;
    for (var a = Array(e + 1); ++r < e; )
      a[r] = n[r];
    return a[e] = g(l), u(i, this, a);
  };
}
export {
  d as default
};
